import { graphql } from 'react-relay';
export const CreateFolderMutation = graphql`
	mutation CreateFolderMutation(
		$parentId: ID
		$spaceKey: String
		$type: String!
		$status: GraphQLContentStatus!
	) {
		createContentContextual(
			input: { parentId: $parentId, spaceKey: $spaceKey, type: $type, status: $status }
		) {
			id
			space {
				id
				key
				alias
			}
		}
	}
`;
